module.exports = require("lodash/set");


//////////////////
// WEBPACK FOOTER
// external "lodash/set"
// module id = 42
// module chunks = 0